export const WarnLimitForLicMgt = 5;

// For Astar
export const AstarFortNoxArticleNumbers = ["IN9920SE", "IN9900SE"];
export const AstarCustomerGroupId = 5;
export const ExcludedLicensesForAstar = ["IN1100SE", "IN1000SE"];
export const InternalEmails = [
  "collinribbaa@gmail.com",
  "isacgunnarsson3@gmail.com",
];

// For result overview
export const FINAL_EXAM_TYPE = {
  PARENT: "parent",
  CHILD: "child",
};
